export default __webpack_public_path__ + "static/media/source-24dp.20d24fbe.svg";